import React, { forwardRef } from 'react';

interface DateInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string;
}

export const DateInput = forwardRef<HTMLInputElement, DateInputProps>(
  ({ className, placeholder, type = 'date', ...rest }, ref) => {
    return (
      <input
        ref={ref}
        type={type}
        className={className}
        placeholder={placeholder}
        {...rest}
      />
    );
  }
);
